module.exports = __webpack_public_path__ + "img/cover-video.430421f.png";